import { State } from 'src/types'
import { listBelt } from '../../listBelt'
import { treasureEmblem } from './treasureEmblem'

export const treasureBeltDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (state.baseModel.brand !== 'treasure') return // treasure以外は return

  const isTreasureEmblem = state.beltType?.value === 'treasureOriginal'
  const isNormalBelt = state.beltType?.value === 'normal'
  if (isNormalBelt) {
    listBelt(ctx, state.listBelt.color, state.stitch.color)
  }
  if (isTreasureEmblem) {
    treasureEmblem(ctx, state?.treasureOriginalParts?.color, state.thumb.color, state.stitch.color, 45, 200, 0.8)
  }
}
